import { SVGProps } from "react";

export default function LinkIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 13, width = 12, fill = "#292D32", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M7.49219 9.25H8.24719C9.75719 9.25 10.9972 8.015 10.9972 6.5C10.9972 4.99 9.76219 3.75 8.24719 3.75H7.49219"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.5 3.75H3.75C2.235 3.75 1 4.985 1 6.5C1 8.01 2.235 9.25 3.75 9.25H4.5"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 6.5H8"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
